import { ENABLE_INACTIVITY_TIMER, DISABLE_INACTIVITY_TIMER  } from './types';

export const enableInactivityTimer = () => ({
    type: ENABLE_INACTIVITY_TIMER,
});

export const disableInactivityTimer = () => ({
    type: DISABLE_INACTIVITY_TIMER,
});
